module.exports = __webpack_public_path__ + "static/Erweiterung_Hotel-f488b07921e83e6e1b291000ee933341.png";